import { useGate, useStore } from 'effector-react'
import { useTranslation } from 'react-i18next'
import { Modal } from '../Modal'
import { $needUpdateApp, Gate, openStore, openStoreFx } from './model'
import { Description, Title } from './styled'

export function ReloadApp() {
  const { t } = useTranslation()

  useGate(Gate)

  const needUpdateApp = useStore($needUpdateApp)
  const isLoading = useStore(openStoreFx.pending)

  return (
    <Modal
      isShow={needUpdateApp}
      onOk={() => openStore()}
      ok={t('button.refresh')}
      isLoading={isLoading}
    >
      <Title>{t('alert.a new version is available')}</Title>
      <br />
      <Description>
        {t('alert.update the app to continue using it')}
      </Description>
    </Modal>
  )
}
